import { render, staticRenderFns } from "./BaseRadio.vue?vue&type=template&id=1b3133de"
import script from "./BaseRadio.vue?vue&type=script&lang=js"
export * from "./BaseRadio.vue?vue&type=script&lang=js"
import style0 from "./BaseRadio.vue?vue&type=style&index=0&id=1b3133de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports